import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

export const getAllPermissions = (params, callback) => {
    return (dispatch, getState) => {
      const {
        user: { token },
      } = getState();
      ApiClient.get(
        `${apiUrl}${PORT}/permission/getAllPermissions`,
        params,
        token,
        dispatch
      ).then((response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      });
    };
  };
  
  export const getAllRoles = (params, callback) => {
    return (dispatch, getState) => {
      const {
        user: { token },
      } = getState();
      ApiClient.get(
        `${apiUrl}${PORT}/role/getAllRolesData`,
        params,
        token,
        dispatch
      ).then((response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      });
    };
  };
  